import React from "react";

import styled from "@emotion/styled";
import shallow from "zustand/shallow";

import useCheckoutStore from "../../store";
import { InlineFlex, SubTitle } from "../index";

const Container = styled.div`
    display: flex;
    flex-flow: column wrap;
    gap: 1em;
    ${({ theme }) => theme.breakpoints.from.medium.css`
        flex-flow: column wrap;
    `}
    ${({ theme }) => theme.breakpoints.upTo.medium.css`
        flex-flow: row wrap;
        justify-content: space-between;
    `}
`;

const Element = styled.div`
    display: flex;
    flex-direction: column;
    min-width: 200px;
`;

const Link = styled.a`
    font-size: 0.75rem;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.darkGrey.toString()};
    text-decoration: underline;

    :hover {
        color: ${({ theme }) => theme.colors.darkGrey.toString()};
    }
`;

interface iFormSummaryProps {
    onEditPayment(): void;
    onEditAddress(): void;
}

const FormSummary = ({ onEditPayment, onEditAddress }: iFormSummaryProps) => {
    const { form } = useCheckoutStore(
        (state) => ({
            form: state.form,
        }),
        shallow
    );
    const { selectedPaymentMethod, setCurrentStep, getSalutationById } =
        useCheckoutStore(
            (state) => ({
                selectedPaymentMethod: state.selectedPaymentMethod,
                setCurrentStep: state.setCurrentStep,
                getSalutationById: state.getSalutationById,
            }),
            shallow
        );

    return (
        <Container>
            <Element>
                <InlineFlex>
                    <SubTitle>Zahlungsart</SubTitle>
                    <Link href="#" onClick={onEditPayment}>
                        Ändern
                    </Link>
                </InlineFlex>

                <span>{selectedPaymentMethod?.name ?? ""}</span>
            </Element>
            <Element>
                <InlineFlex>
                    <SubTitle>
                        {form.hasShippingAddress
                            ? "Rechnungsadresse"
                            : "Adresse"}
                    </SubTitle>
                    <Link href="#" onClick={onEditAddress}>
                        Ändern
                    </Link>
                </InlineFlex>

                {form.billingAddress.company && (
                    <span>{form.billingAddress.company}</span>
                )}

                <span>
                    {getSalutationById(form.salutationId)} {form.firstName}{" "}
                    {form.lastName}
                </span>
                <span>
                    {form.billingAddress.street}{" "}
                    {form.billingAddress.houseNumber}
                </span>
                <span>
                    {form.billingAddress.zipcode} {form.billingAddress.city}
                </span>

                <span>{form.email}</span>
                {form.billingAddress.phoneNumber && (
                    <span>Tel: {form.billingAddress.phoneNumber}</span>
                )}
            </Element>

            {form.hasShippingAddress && (
                <Element>
                    <SubTitle>Lieferadresse</SubTitle>
                    <span>
                        {getSalutationById(form.shippingAddress?.salutationId)}{" "}
                        {form.shippingAddress?.firstName}{" "}
                        {form.shippingAddress?.lastName}
                    </span>
                    <span>
                        {form.shippingAddress?.street}{" "}
                        {form.shippingAddress?.houseNumber}
                    </span>
                    <span>
                        {form.shippingAddress?.zipcode}{" "}
                        {form.shippingAddress?.city}
                    </span>
                </Element>
            )}
        </Container>
    );
};

export default FormSummary;
